module.exports = __webpack_public_path__ + "img/示例图_2.536c6725.png";